module.exports = __webpack_public_path__ + "img/pocket.1e9d9eee.svg";